import { useWindowResize } from 'stimulus-use'
import { useResize } from 'stimulus-use'
import * as echarts from 'echarts'

export const useEcharts = controller => {
    controller.tooltipLocked = false;
    useWindowResize(controller);
    useResize(controller);
    Object.assign(controller, {
        resize({ width }) {
          if(this.chart) { 
            this.chart.resize();
          }
        },
        axisMin(values) {  
          const min =  Math.min(...values)
          const max =  Math.max(...values)
          const range = max - min
          const step = Math.ceil(range / 6)
          const newMin = min - step
          if(newMin < 0 && min >= 0) {
            return 0
          }
          return newMin
        },
        axisMax(values) {
          const min =  Math.min(...values)
          const max =  Math.max(...values)
          const range = max - min
          const step = Math.ceil(range / 6)
          return max + step
        },
        initializeChart(dom, theme = undefined, initOptions = undefined) {
          const existingChart = echarts.getInstanceByDom(dom)
          if (existingChart) existingChart.dispose()

          // Turbo restoration snapshots can retain prior SVG markup; clear it
          // before initializing to avoid visual double-rendering.
          dom.innerHTML = ''

          const chart = echarts.init(dom, theme, initOptions)
          chart.on('finished', () => dom.dispatchEvent(new CustomEvent('chart:finished', { bubbles: true })))
          return chart
        },
        disconnect() {
          if (this.chart) {
            this.chart.dispose();
            this.chart = null;
          }
        },
        windowResize({ width, height, event }) {
          //console.log('useEcharts.windowResize'); 
          if(this.chart) {
            this.chart.resize(); 
          }
        },
        get tooltipClasses() {
          return 'p-0! rounded-none! bg-transparent! border-0! pointer-events-auto!'
        },
        enableLockableTooltips() {
          this.chart.getZr().on('click', (event) => {
            this.toggleTooltipLock(event)
          })      
        },
        toggleTooltipLock(event) {
          this.tooltipLocked = !this.tooltipLocked
          
          if (this.tooltipLocked) {
            // Show tooltip at click position
            this.chart.dispatchAction({
              type: 'showTip',
              x: event.offsetX,
              y: event.offsetY
            })
            
            // Lock it in place
            setTimeout(() => {
              this.chart.setOption({
                tooltip: {
                  triggerOn: 'none',
                  alwaysShowContent: true
                }
              })
            }, 100)
          } else {
            // Restore normal behavior
            this.chart.setOption({
              tooltip: {
                triggerOn: 'mousemove',
                alwaysShowContent: false
              }
            })
            
            this.chart.dispatchAction({
              type: 'hideTip'
            })
          }
        }

         
    });
  };
  
